export default __webpack_public_path__ + "static/media/best_badge.09f96a3d.svg";